import { Component, inject, input, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { DoodProductModel } from '@core/models/product.model';
import { ContentBuilderColorValue } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { ProductPushV2AtomHoverColors } from '@shared/interfaces/product-hover-colors.interface';
import { ProductPushV2AtomComponent } from '@shared/atoms/product-push-v2-atom/product-push-v2-atom.component';
import { InterfaceToInputs } from '@shared/utils/types/interface-to-inputs';
import { ProductColorOverrides } from '@shared/interfaces/product-category-color-overrides.interface';

@Component({
  selector: 'app-product-push-list-atom',
  templateUrl: './product-push-list-atom.component.html',
  standalone: true,
  imports: [ProductPushV2AtomComponent],
})
export class ProductPushListAtomComponent implements InterfaceToInputs<
  ProductColorOverrides,
  { required: true }
> {
  private readonly store = inject(Store);

  displayContext = input('');
  products = input<DoodProductModel[]>([]);
  isOrderingAllowed = input(true);
  productNameColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  productDescriptionColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  productPriceColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  productImagePlaceholderColor = input<ContentBuilderColorValue>({
    value: 'neutral-50',
    type: ColorFieldTypesValues.Palette,
  });
  productBorderColor = input<ContentBuilderColorValue>({
    value: 'neutral-100',
    type: ColorFieldTypesValues.Palette,
  });
  productBackgroundColor = input<ContentBuilderColorValue>({
    value: 'transparent',
    type: ColorFieldTypesValues.Hex,
  });
  productHoverColors = input<ProductPushV2AtomHoverColors | undefined>(undefined);
  tagColors = input.required<ContentBuilderFieldColors>();

  requestGoToProduct = output<DoodProductModel>();
}
